module.exports = __webpack_public_path__ + "media/games-22.6fcbd0b6.mp4";